// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_p5-0";
export var buttonContainer = "_p5-3";
export var cancelButton = "_p5-4";
export var headerSection = "_p5-6";
export var headerTitle = "_p5-9";
export var messageSideLeft = "_p5-1";
export var messageSideRight = "_p5-2";
export var orderNumberContainer = "_p5-7";
export var orderNumberLabel = "_p5-8";
export var submitButton = "_p5-5";